import { Popover } from 'mag-react-components';
import React, { Fragment } from 'react';

import styles from './LayerList.css';
function LayerListItem({ _id, title, visible, definition, onChange }) {
  return (
    <div className={styles.layerListItem}>
      <input
        onChange={() => onChange(_id)}
        type='checkbox'
        defaultChecked={visible}
      />
      {title}
      <Popover definition={definition} title={title} />
      <br />
    </div>
  );
}

export default LayerListItem;
